export default "__VITE_ASSET__DjVcpDiY__"